module.exports = {
	"accept": "accept",
	"acceptcharset": "acceptCharset",
	"accesskey": "accessKey",
	"action": "action",
	"allowfullscreen": "allowFullScreen",
	"allowtransparency": "allowTransparency",
	"alt": "alt",
	"async": "async",
	"autocomplete": "autoComplete",
	"autofocus": "autoFocus",
	"autoplay": "autoPlay",
	"capture": "capture",
	"cellpadding": "cellPadding",
	"cellspacing": "cellSpacing",
	"charset": "charSet",
	"challenge": "challenge",
	"checked": "checked",
	"classid": "classID",
	"class": "className",
	"cols": "cols",
	"colspan": "colSpan",
	"content": "content",
	"contenteditable": "contentEditable",
	"contextmenu": "contextMenu",
	"controls": "controls",
	"coords": "coords",
	"crossorigin": "crossOrigin",
	"data": "data",
	"datetime": "dateTime",
	"defer": "defer",
	"dir": "dir",
	"disabled": "disabled",
	"download": "download",
	"draggable": "draggable",
	"enctype": "encType",
	"form": "form",
	"formaction": "formAction",
	"formenctype": "formEncType",
	"formmethod": "formMethod",
	"formnovalidate": "formNoValidate",
	"formtarget": "formTarget",
	"frameborder": "frameBorder",
	"headers": "headers",
	"height": "height",
	"hidden": "hidden",
	"high": "high",
	"href": "href",
	"hreflang": "hrefLang",
	"for": "htmlFor",
	"httpequiv": "httpEquiv",
	"icon": "icon",
	"id": "id",
	"inputmode": "inputMode",
	"keyparams": "keyParams",
	"keytype": "keyType",
	"label": "label",
	"lang": "lang",
	"list": "list",
	"loop": "loop",
	"low": "low",
	"manifest": "manifest",
	"marginheight": "marginHeight",
	"marginwidth": "marginWidth",
	"max": "max",
	"maxlength": "maxLength",
	"media": "media",
	"mediagroup": "mediaGroup",
	"method": "method",
	"min": "min",
	"minlength": "minLength",
	"multiple": "multiple",
	"muted": "muted",
	"name": "name",
	"novalidate": "noValidate",
	"open": "open",
	"optimum": "optimum",
	"pattern": "pattern",
	"placeholder": "placeholder",
	"poster": "poster",
	"preload": "preload",
	"radiogroup": "radioGroup",
	"readonly": "readOnly",
	"rel": "rel",
	"required": "required",
	"role": "role",
	"rows": "rows",
	"rowspan": "rowSpan",
	"sandbox": "sandbox",
	"scope": "scope",
	"scoped": "scoped",
	"scrolling": "scrolling",
	"seamless": "seamless",
	"selected": "selected",
	"shape": "shape",
	"size": "size",
	"sizes": "sizes",
	"span": "span",
	"spellcheck": "spellCheck",
	"src": "src",
	"srcdoc": "srcDoc",
	"srcset": "srcSet",
	"start": "start",
	"step": "step",
	"style": "style",
	"summary": "summary",
	"tabindex": "tabIndex",
	"target": "target",
	"title": "title",
	"type": "type",
	"usemap": "useMap",
	"value": "value",
	"width": "width",
	"wmode": "wmode",
	"wrap": "wrap",
	"clippath": "clipPath",
	"cx": "cx",
	"cy": "cy",
	"d": "d",
	"dx": "dx",
	"dy": "dy",
	"fill": "fill",
	"fillopacity": "fillOpacity",
	"fontfamily": "fontFamily",
	"fontsize": "fontSize",
	"fx": "fx",
	"fy": "fy",
	"gradienttransform": "gradientTransform",
	"gradientunits": "gradientUnits",
	"markerend": "markerEnd",
	"markermid": "markerMid",
	"markerstart": "markerStart",
	"offset": "offset",
	"opacity": "opacity",
	"patterncontentunits": "patternContentUnits",
	"patternunits": "patternUnits",
	"points": "points",
	"preserveaspectratio": "preserveAspectRatio",
	"r": "r",
	"rx": "rx",
	"ry": "ry",
	"spreadmethod": "spreadMethod",
	"stopcolor": "stopColor",
	"stopopacity": "stopOpacity",
	"stroke": "stroke",
	"strokedasharray": "strokeDasharray",
	"strokelinecap": "strokeLinecap",
	"strokeopacity": "strokeOpacity",
	"strokewidth": "strokeWidth",
	"textanchor": "textAnchor",
	"transform": "transform",
	"version": "version",
	"viewbox": "viewBox",
	"x1": "x1",
	"x2": "x2",
	"x": "x",
	"xlinkactuate": "xlinkActuate",
	"xlinkarcrole": "xlinkArcrole",
	"xlinkhref": "xlinkHref",
	"xlinkrole": "xlinkRole",
	"xlinkshow": "xlinkShow",
	"xlinktitle": "xlinkTitle",
	"xlinktype": "xlinkType",
	"xmlbase": "xmlBase",
	"xmllang": "xmlLang",
	"xmlspace": "xmlSpace",
	"y1": "y1",
	"y2": "y2",
	"y": "y",
	"oncopy": "onCopy",
	"oncut": "onCut",
	"onpaste": "onPaste",
	"oncompositionend": "onCompositionEnd",
	"oncompositionstart": "onCompositionStart",
	"oncompositionupdate": "onCompositionUpdate",
	"onkeydown": "onKeyDown",
	"onkeypress": "onKeyPress",
	"onkeyup": "onKeyUp",
	"onfocus": "onFocus",
	"onblur": "onBlur",
	"onchange": "onChange",
	"oninput": "onInput",
	"onsubmit": "onSubmit",
	"onclick": "onClick",
	"oncontextmenu": "onContextMenu",
	"ondoubleclick": "onDoubleClick",
	"ondrag": "onDrag",
	"ondragend": "onDragEnd",
	"ondragenter": "onDragEnter",
	"ondragexit": "onDragExit",
	"ondragleave": "onDragLeave",
	"ondragover": "onDragOver",
	"ondragstart": "onDragStart",
	"ondrop": "onDrop",
	"onmousedown": "onMouseDown",
	"onmouseenter": "onMouseEnter",
	"onmouseleave": "onMouseLeave",
	"onmousemove": "onMouseMove",
	"onmouseout": "onMouseOut",
	"onmouseover": "onMouseOver",
	"onmouseup": "onMouseUp",
	"onselect": "onSelect",
	"ontouchcancel": "onTouchCancel",
	"ontouchend": "onTouchEnd",
	"ontouchmove": "onTouchMove",
	"ontouchstart": "onTouchStart",
	"onscroll": "onScroll",
	"onwheel": "onWheel",
	"onabort": "onAbort",
	"oncanplay": "onCanPlay",
	"oncanplaythrough": "onCanPlayThrough",
	"ondurationchange": "onDurationChange",
	"onemptied": "onEmptied",
	"onencrypted": "onEncrypted",
	"onended": "onEnded",
	"onerror": "onError",
	"onloadeddata": "onLoadedData",
	"onloadedmetadata": "onLoadedMetadata",
	"onloadstart": "onLoadStart",
	"onpause": "onPause",
	"onplay": "onPlay",
	"onplaying": "onPlaying",
	"onprogress": "onProgress",
	"onratechange": "onRateChange",
	"onseeked": "onSeeked",
	"onseeking": "onSeeking",
	"onstalled": "onStalled",
	"onsuspend": "onSuspend",
	"ontimeupdate": "onTimeUpdate",
	"onvolumechange": "onVolumeChange",
	"onwaiting": "onWaiting",
	"onload": "onLoad"
};


//////////////////
// WEBPACK FOOTER
// ./~/react-attr-converter/map.json
// module id = 772
// module chunks = 0